/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AzureServiceBusConfig,
  AzureServiceBusConfig$inboundSchema,
  AzureServiceBusConfig$Outbound,
  AzureServiceBusConfig$outboundSchema,
} from "./azureservicebusconfig.js";
import {
  AzureServiceBusCredentials,
  AzureServiceBusCredentials$inboundSchema,
  AzureServiceBusCredentials$Outbound,
  AzureServiceBusCredentials$outboundSchema,
} from "./azureservicebuscredentials.js";
import {
  Topics,
  Topics$inboundSchema,
  Topics$Outbound,
  Topics$outboundSchema,
} from "./topics.js";

export type DestinationCreateAzureServiceBus = {
  /**
   * Optional user-provided ID. A UUID will be generated if empty.
   */
  id?: string | undefined;
  /**
   * Type of the destination. Must be 'azure_servicebus'.
   */
  type: "azure_servicebus";
  /**
   * "*" or an array of enabled topics.
   */
  topics: Topics;
  /**
   * Optional JSON schema filter for event matching. Events must match this filter to be delivered to this destination.
   *
   * @remarks
   * Supports operators: $eq, $neq, $gt, $gte, $lt, $lte, $in, $nin, $startsWith, $endsWith, $exist, $or, $and, $not.
   * If null or empty, all events matching the topic filter will be delivered.
   * To remove an existing filter when updating a destination, set filter to an empty object `{}`.
   */
  filter?: { [k: string]: any } | null | undefined;
  config: AzureServiceBusConfig;
  credentials: AzureServiceBusCredentials;
  /**
   * Static key-value pairs merged into event metadata on every attempt.
   */
  deliveryMetadata?: { [k: string]: string } | null | undefined;
  /**
   * Arbitrary contextual information stored with the destination.
   */
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationCreateAzureServiceBus$inboundSchema: z.ZodType<
  DestinationCreateAzureServiceBus,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string().optional(),
  type: z.literal("azure_servicebus"),
  topics: Topics$inboundSchema,
  filter: z.nullable(z.record(z.any())).optional(),
  config: AzureServiceBusConfig$inboundSchema,
  credentials: AzureServiceBusCredentials$inboundSchema,
  delivery_metadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    "delivery_metadata": "deliveryMetadata",
  });
});
/** @internal */
export type DestinationCreateAzureServiceBus$Outbound = {
  id?: string | undefined;
  type: "azure_servicebus";
  topics: Topics$Outbound;
  filter?: { [k: string]: any } | null | undefined;
  config: AzureServiceBusConfig$Outbound;
  credentials: AzureServiceBusCredentials$Outbound;
  delivery_metadata?: { [k: string]: string } | null | undefined;
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationCreateAzureServiceBus$outboundSchema: z.ZodType<
  DestinationCreateAzureServiceBus$Outbound,
  z.ZodTypeDef,
  DestinationCreateAzureServiceBus
> = z.object({
  id: z.string().optional(),
  type: z.literal("azure_servicebus"),
  topics: Topics$outboundSchema,
  filter: z.nullable(z.record(z.any())).optional(),
  config: AzureServiceBusConfig$outboundSchema,
  credentials: AzureServiceBusCredentials$outboundSchema,
  deliveryMetadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    deliveryMetadata: "delivery_metadata",
  });
});

export function destinationCreateAzureServiceBusToJSON(
  destinationCreateAzureServiceBus: DestinationCreateAzureServiceBus,
): string {
  return JSON.stringify(
    DestinationCreateAzureServiceBus$outboundSchema.parse(
      destinationCreateAzureServiceBus,
    ),
  );
}
export function destinationCreateAzureServiceBusFromJSON(
  jsonString: string,
): SafeParseResult<DestinationCreateAzureServiceBus, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DestinationCreateAzureServiceBus$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DestinationCreateAzureServiceBus' from JSON`,
  );
}
